import React, { Fragment } from 'react';
import { Datagrid, Filter, TextField, TextInput, TopToolbar, usePermissions } from 'react-admin';

import { List } from '~/layout';
import { NoPermissions, StatusField } from '~/components/ra';

import PaymentServiceCreateAction from './components/PaymentServiceCreateAction';
import { useDefaultListFilterStyles } from '~/hooks/useListFilterStyles';
import { PlusField } from '~/components';
import { FunctionField } from 'react-admin';
import { ChipField } from 'react-admin';
import { isEmpty } from 'lodash';
import { Longdash } from '~/utils';
import OperationTypeField from '~/components/OperationTypeField';

const l = (key: string): string => `resources.paymentServices.list.${key}`;

const PaymentServiceListActions = () => {
  const { permissions } = usePermissions();

  if (!permissions) return null;

  return (
    <TopToolbar>
      <PaymentServiceCreateAction />
    </TopToolbar>
  );
};

const PaymentServiceList = (props: any) => {
  const { permissions } = usePermissions();
  const classes = useDefaultListFilterStyles();

  if (!permissions) return null;
  if (!permissions?.includes('paymentService.list')) return <NoPermissions />;

  return (
    <Fragment>
      <List
        bulkActionButtons={false}
        {...props}
        actions={<PaymentServiceListActions {...props} />}
        filters={
          <Filter className={classes.form}>
            <TextInput label={l('id')} source='id' alwaysOn className={classes.formControl} />
            <TextInput label={l('name')} source='name' alwaysOn className={classes.formControl} />
            <TextInput
              label={l('partnerId')}
              source='partnerId'
              alwaysOn
              className={classes.formControl}
            />
            <TextInput
              label={l('templateId')}
              source='templateId'
              alwaysOn
              className={classes.formControl}
            />
          </Filter>
        }
      >
        <Datagrid rowClick='show' size='medium' selectedIds={null}>
          <TextField source='id' label={l('id')} sortable={false} />
          <TextField source='name' label={l('name')} sortable={false} />
          <TextField source='templateId' label={l('templateId')} sortable={false} />
          <TextField source='partnerId' label={l('partnerId')} sortable={false} />
          <FunctionField
            label={l('operationType')}
            render={(record: any) => {
              if (!record || isEmpty(record?.operationType)) return Longdash;
              return <OperationTypeField operationType={record.operationType} />;
            }}
          />
          <TextField source='processing.flow' label={l('processingFlow')} sortable={false} />
          <FunctionField
            label={l('tags')}
            render={(record: any) => {
              if (!record || isEmpty(record.tags)) return Longdash;
              return (
                <PlusField
                  items={record.tags}
                  mainComponent={(tag) => (
                    <ChipField record={{ name: tag }} source='name' key={tag} />
                  )}
                  tooltipsComponent={(tag) => (
                    <ChipField record={{ name: tag }} source='name' key={tag} />
                  )}
                />
              );
            }}
          />
          <StatusField source='status' defaultValue='ACTIVE' sortable={false} />
        </Datagrid>
      </List>
    </Fragment>
  );
};

export default PaymentServiceList;
